import service from "@/store/services/sync-logs-service";

export const state = () => ({
  list: {},
  syncLog: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, syncLog) => {
    if (syncLog.syncLogable == null) {
      syncLog.syncLogable = {};
    }
    state.syncLog = syncLog;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((syncLog) => {
      commit("SET_RESOURCE", syncLog);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((syncLog) => {
      commit("SET_RESOURCE", syncLog);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((syncLog) => {
      commit("SET_RESOURCE", syncLog);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  retry({ commit, dispatch }, params) {
    return service.retry(params, this.$axios);
  },

  toggleAttempts({ commit, dispatch }, params) {
    return service.toggleAttempts(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  syncLog: (state) => state.syncLog,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((syncLog) => ({
      id: syncLog.id,
      name: `${syncLog.firstname} ${syncLog.lastname}`,
    }));
  },
};

const syncLogs = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default syncLogs;
